import { useSelector, useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Snackbar as FinanceableSnackbar,
  IconButton,
  Stack,
  Typography,
  Ul,
  UlItem,
} from "@financeable-com-au/financeable-ui";
import { snackbarSelector, closeSnackbar } from "@/store/slices/snackbarSlice";

const autoHideDuration = 5000;

const Snackbar = () => {
  const { description, intent, message, open } = useSelector(snackbarSelector);
  const dispatch = useDispatch();

  const textColor = `${intent ?? "success"}.200`;
  const hasDescription = Boolean(description?.length);

  return (
    <FinanceableSnackbar
      autoHideDuration={autoHideDuration}
      open={open}
      intent={intent ?? "success"}
      startDecorator={<InfoOutlinedIcon sx={{ fontSize: "1rem" }} />}
      onClose={() => {
        dispatch(closeSnackbar());
      }}
      endDecorator={
        <IconButton
          data-testid="close-button"
          variant="inline"
          onClick={() => {
            dispatch(closeSnackbar());
          }}
          intent={intent ?? "success"}
        >
          <CloseIcon sx={{ fontSize: "1rem" }} />
        </IconButton>
      }
    >
      <Stack rowGap={1}>
        <Typography level="body-sm" textColor={textColor}>
          {message}
        </Typography>
        {hasDescription ? (
          <Ul sx={{ "--ListItem-minHeight": "1.2rem" }} textColor={textColor}>
            {description?.map((item) => (
              <UlItem key={item} sx={{ py: 0 }}>
                <Typography level="body-xs" lineHeight={1.2} textColor={textColor}>
                  {item}
                </Typography>
              </UlItem>
            ))}
          </Ul>
        ) : null}
      </Stack>
    </FinanceableSnackbar>
  );
};

export { Snackbar };
